import React, { useCallback, useRef, useState } from "react";
import { MenuItems, BannerData } from "@bloomberg/media-ui-nav/dist/types";
import { NavProvider } from "@foundation/nav";

import ContextualNavContainer from "~components/ContextualNavContainer";
import NavContainer from "~components/Nav";
import { Story } from "~types/types";
import { useScrolling } from "~utils/useScrolling";

import styles from "./NavAndContextualNav.module.css";

type NavAndContextualNavProps = {
    menuItems: MenuItems | null;
    breakingNews: BannerData;
    story: Story;
    countryCode?: string;
};

export const NavAndContextualNav = ({
    menuItems,
    breakingNews,
    story,
    countryCode,
}: NavAndContextualNavProps) => {
    const navRef = useRef<HTMLDivElement | null>(null);
    const [transitionCSS, setTransitionCSS] = useState({ top: "0px" });
    const onScrollUpCallback = useCallback(() => {
        setTransitionCSS({ top: "0px" });
    }, []);

    const onScrollDownCallback = useCallback(() => {
        if (navRef.current) {
            const componentHeight = navRef.current.clientHeight;
            setTransitionCSS({ top: `-${componentHeight}px` });
        }
    }, [navRef.current]);

    useScrolling({
        ref: navRef,
        scrollDirectionThreshold: 30,
        onScrollUpCallback,
        onScrollDownCallback,
    });

    return (
        <div className={styles.nav} style={transitionCSS}>
            <div ref={navRef}>
                <NavProvider>
                    <NavContainer
                        menuItems={menuItems}
                        useGrid
                        breakingNews={breakingNews}
                        countryCode={countryCode}
                    />
                </NavProvider>
            </div>
            {story && <ContextualNavContainer firstStory={story} />}
        </div>
    );
};
